const shopRoot = window.Shopify?.routes?.root || '/';

const openDialog = (dialog) => {
  if (!dialog) return;
  dialog.showModal();
  document.body.classList.add('has-dialog');
};

const closeDialog = (dialog) => {
  if (!dialog) return;
  dialog.close();
  document.body.classList.remove('has-dialog');
};

document.addEventListener('click', async (event) => {
  const closeButton = event.target.closest('[data-dialog-close]');
  if (closeButton) closeDialog(closeButton.closest('dialog'));

  const mediaButton = event.target.closest('[data-media-target]');
  if (mediaButton) {
    const gallery = mediaButton.closest('[data-product-gallery]');
    gallery.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-hidden', item.dataset.mediaId !== mediaButton.dataset.mediaTarget));
    gallery.querySelectorAll('[data-media-target]').forEach((button) => {
      const active = button === mediaButton;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
  }

  const zoomButton = event.target.closest('[data-image-zoom]');
  if (zoomButton) {
    const image = zoomButton.querySelector('img');
    const dialog = document.querySelector('[data-image-zoom-dialog]');
    const content = dialog?.querySelector('[data-image-zoom-content]');
    if (image && content) {
      content.replaceChildren(image.cloneNode());
      openDialog(dialog);
    }
  }

  const quickViewButton = event.target.closest('[data-quick-view]');
  if (quickViewButton) {
    quickViewButton.disabled = true;
    try {
      const response = await fetch(quickViewButton.dataset.quickView, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Quick view failed with ${response.status}`);
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const productDetail = documentFragment.querySelector('.product-detail');
      const dialog = document.querySelector('[data-quick-view-dialog]');
      const content = dialog?.querySelector('[data-quick-view-content]');
      if (productDetail && content) {
        content.replaceChildren(productDetail);
        initializeProductForms(content);
        openDialog(dialog);
      }
    } finally {
      quickViewButton.disabled = false;
    }
  }
});

const refreshCartDrawer = async () => {
  const response = await fetch(`${shopRoot}cart?section_id=cart-drawer`);
  if (!response.ok) throw new Error(`Cart refresh failed with ${response.status}`);
  const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
  const nextDrawer = nextDocument.querySelector('[data-cart-drawer]');
  const currentDrawer = document.querySelector('[data-cart-drawer]');
  if (nextDrawer && currentDrawer) currentDrawer.replaceWith(nextDrawer);

  const cartResponse = await fetch(`${shopRoot}cart.js`);
  if (!cartResponse.ok) throw new Error(`Cart count failed with ${cartResponse.status}`);
  const cart = await cartResponse.json();
  document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
  return document.querySelector('[data-cart-drawer]');
};

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const originalText = button?.textContent;
  if (button) { button.disabled = true; button.textContent = 'Adding…'; }

  try {
    const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error(`Add to cart failed with ${response.status}`);
    if (document.body.dataset.cartDrawerEnabled === 'true') {
      const drawer = await refreshCartDrawer();
      if (drawer) drawer.hidden = false;
      document.body.classList.add('has-cart-drawer');
    } else {
      window.location.assign(`${shopRoot}cart`);
    }
  } finally {
    if (button) { button.disabled = false; button.textContent = originalText; }
  }
});

const initializeProductForms = (root = document) => {
  root.querySelectorAll('[data-product-form]').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const variants = JSON.parse(form.querySelector('[data-product-variants]')?.textContent || '[]');
    const variantInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-to-cart]');
    const productRoot = form.closest('[data-product-page], .product-detail');

    const updateVariant = () => {
      const selections = [...form.querySelectorAll('[data-product-option]')].map((select) => select.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selections[index])) || variants[0];
      if (!variant || !variantInput || !button) return;
      variantInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const price = productRoot?.querySelector('[data-product-price]');
      if (price && window.Shopify?.currency?.active) price.textContent = new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: window.Shopify.currency.active }).format(variant.price / 100);
      document.querySelectorAll('[data-pickup-variant]').forEach((pickup) => { pickup.hidden = pickup.dataset.pickupVariant !== String(variant.id); });
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('variant', variant.id);
      history.replaceState({}, '', nextUrl);
    };

    form.querySelectorAll('[data-product-option]').forEach((select) => select.addEventListener('change', updateVariant));
  });
};

initializeProductForms();

document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
  if (!section.dataset.url) return;
  const response = await fetch(section.dataset.url);
  if (!response.ok) return;
  const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
  const nextSection = nextDocument.querySelector('[data-product-recommendations]');
  if (nextSection?.innerHTML.trim()) section.replaceWith(nextSection);
});

const viewedKey = 'tosa-recently-viewed';
const productPage = document.querySelector('[data-product-page]');
if (productPage && document.body.dataset.recentlyViewedEnabled === 'true') {
  const image = productPage.querySelector('.product-detail-image img');
  const current = { handle: productPage.dataset.productHandle, title: productPage.dataset.productTitle, url: productPage.dataset.productUrl, price: productPage.dataset.productPrice, image: image?.currentSrc || image?.src || '' };
  const existing = JSON.parse(localStorage.getItem(viewedKey) || '[]').filter((item) => item.handle !== current.handle);
  localStorage.setItem(viewedKey, JSON.stringify([current, ...existing].slice(0, 8)));
}

document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
  if (document.body.dataset.recentlyViewedEnabled !== 'true') return;
  const currentHandle = productPage?.dataset.productHandle;
  const products = JSON.parse(localStorage.getItem(viewedKey) || '[]').filter((item) => item.handle !== currentHandle).slice(0, 4);
  const grid = section.querySelector('[data-recently-viewed-grid]');
  products.forEach((product) => {
    const article = document.createElement('article');
    article.className = 'product-card';
    const link = document.createElement('a');
    link.href = product.url;
    const image = new Image();
    image.src = product.image;
    image.alt = product.title;
    image.loading = 'lazy';
    const heading = document.createElement('h3');
    heading.textContent = product.title;
    const price = document.createElement('p');
    price.textContent = product.price;
    link.append(image, heading);
    article.append(link, price);
    grid.append(article);
  });
  section.hidden = products.length === 0;
});
